// extracted by mini-css-extract-plugin
module.exports = {"inPlay":"_b920942","inPlayIcon":"_92ff213","inPlayXs":"_f33c5ab","inPlaySm":"_95e693b","separator":"_8865ac1"};